import React from 'react';

const ArrowRightIcon = () => {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.70711 0.292893L8.07107 6.65685C8.46159 7.04738 8.46159 7.68054 8.07107 8.07107L1.70711 14.435C1.31658 14.8256 0.683418 14.8256 0.292893 14.435C-0.0976311 14.0445 -0.0976311 13.4113 0.292893 13.0208L5.94975 7.36396L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893Z"
        fill="white"
      />
    </svg>
  );
};

export default ArrowRightIcon;
